<template>
  <article class="ts-notebook-item position-relative d-flex align-items-start gap-2">
    <div class="flex-grow-1 min-w-0">
      <a href="#" class="ts-notebook-item-title stretched-link" @click.prevent="$emit('open')">{{ title }}</a>
      <div class="ts-notebook-item-meta d-flex flex-wrap gap-3 mt-1">
        <span>ID: {{ id }}</span>
        <span v-if="description"><i class="bi bi-geo-alt me-1" aria-hidden="true"></i>{{ description }}</span>
        <span v-if="date"><i class="bi bi-clock-history me-1" aria-hidden="true"></i>{{ date }}</span>
      </div>
    </div>
    <!-- above the stretched link so it does not open the entry -->
    <button
      class="btn btn-link ts-notebook-item-delete position-relative"
      type="button"
      :title="translations[2837]"
      :aria-label="`${translations[2837]}: ${title}`"
      @click="$emit('delete')"
    >
      <i class="bi bi-trash" aria-hidden="true"></i>
    </button>
  </article>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Prop, Vue } from 'vue-property-decorator';

// One saved job, applicant, company or course in the notebook
@Component
export default class NotebookItem extends Vue {
  @Prop({ default: '' }) private date!: string;

  @Prop({ default: '' }) private title!: string;

  @Prop({ default: '' }) private description!: string;

  @Prop({ default: 0 }) private id!: number;

  get translations() {
    return AppModule.translation;
  }
}
</script>

<style scoped lang="scss">
.ts-notebook-item {
  padding: var(--ts-space-3) 0;

  & + & {
    border-top: 1px solid var(--ts-border);
  }
}

.ts-notebook-item-title {
  color: var(--ts-dark);
  font-weight: 600;
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
}

.ts-notebook-item-meta {
  color: var(--ts-muted);
  font-size: var(--ts-fs-sm);
}

.ts-notebook-item-delete {
  z-index: 2;
  padding: var(--ts-space-1) var(--ts-space-2);
  color: var(--ts-muted);

  &:hover,
  &:focus {
    color: var(--bs-danger);
  }
}
</style>
